// Lucide icon: arrow-down (https://lucide.dev/icons/arrow-down)
import { ArrowDown } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconPointerDown = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ArrowDown />
    </IconComponentStyled>
  )
}
